

class PodcastBannerSlider {
  constructor (parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.slider();
  }

  slider = () => {
    let sliders = qsa('.podcast-main-banner-slider-js');
    sliders?.forEach(element => {
      
      let PodcastBannerSliderSlide = element.dataset.slide;
      let PodcastBannerSliderClass = element;
      this.PodcastBannerSlider(PodcastBannerSliderClass,PodcastBannerSliderSlide);
    });
  }

  PodcastBannerSlider = (sliderClass) => {
    new Swiper(sliderClass, {
      loop: false,
      slidesPerView: 4,
      slidesPerGroup: 1,
      autoHeight:true,
      speed: 1000,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination-podcast',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        1: {
          slidesPerView: 1,
          spaceBetween: 60,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 60,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 60,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

new PodcastBannerSlider(qs('.podcast-banner-section-main'));